export default {
	REVERT: "REVERT",
    RESUME: "RESUME",
    MAIN: "MAIN",
    RESPIN: "RESPIN",
    COMET_WILDS: "COMET_WILDS",
    BONUS_COUNTDOWN: "BONUS_COUNTDOWN",
    BONUS_INTRO: "BONUS_INTRO",
    PICK: "PICK",
    FREESPIN: "FREESPIN",
    MARS_INTRO: "MARS_INTRO",
    JACKPOT_DRAW: "JACKPOT_DRAW"
}
